const addOnClickOnAllItems = (items, onClick) => {
  for (let index = 0; index < items.length; index++) {
    const item = items[index];
    item.addEventListener('click', onClick);
  }
};

const removeAllActiveItemsFromList = (list) => {
  for (let index = 0; index < list.length; index++) {
    const item = list[index];
    item.classList.remove('active');
  }
};

const appendActiveClassNameToNavListItem = (element) => {
  element.classList.add('active');
};

const hideAllTheActiveContentSectionsFromList = (list) => {
  for (let index = 0; index < list.length; index++) {
    const item = list[index];
    item.classList.remove('active');
  }
};

const recreateElement = (element) => {
  const clonedElement = element.cloneNode(true);
  element.parentNode.replaceChild(clonedElement, element);
};

const showElementContent = (elementClass) => {
  const combinedClassName = `.${elementClass}-content`;
  const elementContent = document.querySelector(combinedClassName);
  elementContent.classList.add('active');
};

const toggleActiveListItems = (element, navItems, contentItems) => {
  removeAllActiveItemsFromList(navItems);
  appendActiveClassNameToNavListItem(element);

  const elementClassName = element.classList[1];

  hideAllTheActiveContentSectionsFromList(contentItems);

  showElementContent(elementClassName);
};

export {
  addOnClickOnAllItems,
  removeAllActiveItemsFromList,
  appendActiveClassNameToNavListItem,
  hideAllTheActiveContentSectionsFromList,
  recreateElement,
  showElementContent,
  toggleActiveListItems
};
